import React from 'react';
import { elements } from '@ecosystem/newron-design-system';
import { Entity } from '../../types';

type Props = {
  isOpen: boolean;
  options: Entity[];
  isMulti?: boolean;
  onItemClick: (value: string) => void;
  value: string | string[];
};
function SelectionMenu({ isOpen, options, isMulti, onItemClick, value }: Props) {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      style={{ maxHeight: '240px' }}
      className="absolute left-0 text-md top-full mt-1 z-10 w-content bg-white rounded border border-light font-normal overflow-y-auto overscroll-contain"
    >
      {options.map(opt => (
        <MenuItem
          key={opt.value}
          option={opt}
          isActive={opt.value === value}
          canBeUnselected={isMulti}
          onClick={() => onItemClick(opt.value)}
        />
      ))}
    </div>
  );
}

type ItemProps = {
  option: Entity;
  isActive: boolean;
  canBeUnselected?: boolean;
  onClick: () => void;
};
function MenuItem({ option, isActive, onClick, canBeUnselected = false }: ItemProps) {
  const { Icon } = elements;

  if (isActive && !canBeUnselected) {
    return (
      <div className="py-2 px-4 flex items-center">
        <div className="flex-grow">{option.label}</div>
        <Icon>
          <Icon.icons.Check />
        </Icon>
      </div>
    );
  }

  return (
    <button
      onClick={onClick}
      className="w-full px-4 flex items-center gap-1 py-2 text-left transition-colors hover:bg-brand-light"
    >
      <span className="flex-grow nowrap">{option.label}</span>
      <span className={isActive ? 'visible' : 'hidden'}>
        <Icon>
          <Icon.icons.Check />
        </Icon>
      </span>
    </button>
  );
}

export { SelectionMenu };
